import React from 'react';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { MobileOnly, DesktopOnly } from 'shared/components';
import { useLoyaltyPassUrl } from 'src/components/loyalty/use-get-loyalty-pass-url';
import { AddToWalletMobile } from './mobile/add-to-wallet';
import { AddToWalletDesktop } from './desktop/add-to-wallet';

const DESCRIPITON = 'Simply show your pass at the register to pay using your linked bank account.';

export const AddToWallet = (): JSX.Element | null => {
  const { dispensary } = useDispensary();
  const dispensaryName = dispensary?.name ?? '';
  const { loyaltyPassUrl, loyaltyPassShortUrl, loyaltyPassUrlLoading, loyaltyPassUrlError } = useLoyaltyPassUrl({
    requirePayByBankEnrollment: true,
  });

  const shouldShowLoyaltyPass = !!loyaltyPassUrl && !loyaltyPassUrlLoading && !loyaltyPassUrlError;

  if (!shouldShowLoyaltyPass) {
    return null;
  }

  const title = `Pay with your phone using your ${dispensaryName} pass.`;

  return (
    <>
      <MobileOnly>
        {!!loyaltyPassUrl && <AddToWalletMobile url={loyaltyPassUrl} title={title} description={DESCRIPITON} />}
      </MobileOnly>
      <DesktopOnly>
        {/* We are using the short URL for desktop to simplify the QR Code */}
        {!!loyaltyPassShortUrl && (
          <AddToWalletDesktop url={loyaltyPassShortUrl} title={title} description={DESCRIPITON} />
        )}
      </DesktopOnly>
    </>
  );
};
